import LiuCheng from './liucheng';


export default {
    path: 'liucheng',
    component: () => import('@layout/empty'),
    children: [
        LiuCheng,
    ]
}
